import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import VueWindowSize from 'vue-window-size'
import VueRouter from 'vue-router'
const abbreviate = require('number-abbreviate')

Vue.use(VueWindowSize)
Vue.use(VueRouter)

Vue.filter('abbreviate', function abbreviateNumber (value, diff) {
  if (diff > 0 && Math.floor(Math.log10(diff))) {
    return abbreviate(value, Math.max(0, 1 + Math.floor(Math.log10(value)) - Math.floor(Math.log10(diff))))
  } else {
    return value
  }
})

Vue.config.productionTip = false

new Vue({
  store,
  vuetify,
  router: new VueRouter({ mode: 'history', base: new URL(window.APPLICATION.exposedUrl).pathname }),
  render: h => h(App)
}).$mount('#app')
